const config = {
	palette: {
		primary: "#0397AC",
		secondary: "#3D454B",
		type: "light"
	}
};

export default config;
